export const getFingerprint = (): string => {
  const ratio =
    window.screen.height +
    window.screen.width +
    window.devicePixelRatio +
    window.navigator.hardwareConcurrency;

  return (
    ratio.toString() +
    window.navigator.languages.join(",") +
    window.navigator.userAgent
  );
};
